<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
<div [ngClass]="passrequestId > 0 ? 'page-content-wrapper' : ''">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Person On Board</a>
      </li>
    </ol>
    <div class="inner-wrapper">
      <div [ngClass]="passrequestId > 0 ? 'sub-wrapper' : ''">
        <h3
          *ngIf="passrequestId > 0"
          class="page-title obs-card-title"
          style="text-align: center"
        >
          <span class="page-sub-title">
            <ng-container *ngIf="passrequestId > 0"
              >Pass {{ passRequestForFormData.PassId }}</ng-container
            > </span
          ><button
            *ngIf="passrequestId > 0"
            (click)="isNext ? onNextClick() : $event.preventDefault()"
            [ngClass]="isNext ? 'cursor-pointer' : 'disabled'"
            class="pull-right btn btn-primary primary-btn"
          >
            <i class="fa fa-angle-right"></i>
          </button>
          <button
            *ngIf="passrequestId > 0"
            (click)="isPrevious ? onPreviousClick() : $event.preventDefault()"
            [ngClass]="isPrevious ? 'cursor-pointer' : 'disabled'"
            class="pull-right btn btn-primary primary-btn"
          >
            <i class="fa fa-angle-left"></i>
          </button>
        </h3>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >Unit Name
              <span class="mandatory">*</span>
            </span>
            <input
              type="text"
              pInputText
              placeholder="Unit Name"
              [value]="UnitName"
              disabled
              style="color: Black"
            />
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              Pass Type
              <span class="mandatory">*</span>
            </span>
            <input
              type="text"
              pInputText
              placeholder="Pass Type"
              [value]="passTypeRowNameValue"
              disabled
              style="color: Black"
            />
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >Location
              <span class="mandatory">*</span>
            </span>
            <input
              type="text"
              pInputText
              placeholder="Location"
              [value]="LocationName"
              disabled
              style="color: Black"
            />
          </div>
          <div *ngIf="isInactiveLocation">
            <span class="error-msg-colour">This Location is In Active.</span>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >Full Name
              <span class="mandatory">*</span>
            </span>
            <ng-container *ngIf="passTypeRowNameValue === 'Contractor'">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="passRequestForFormData.FullName"
                [disabled]="disablePOB"
              />
            </ng-container>
            <ng-container *ngIf="passTypeRowNameValue === 'Staff'">
              <p-autoComplete
                [(ngModel)]="passRequestForFormData.FullNameUser"
                [suggestions]="userResults"
                (completeMethod)="getUsersOnSearch($event)"
                (onSelect)="selectActionOwner($event)"
                (change)="selectActionOwner($event)"
                placeholder="Full Name"
                appendTo="body"
                [disabled]="disablePOB"
                field="FullName"
                [minLength]="1"
                [style]="{ width: '100%' }"
                [inputStyle]="{ width: '100%' }"
                [forceSelection]="
                  passTypeRowNameValue === 'Staff' ? true : false
                "
              >
                <ng-template let-user pTemplate="item">
                  <span [title]="user.Email">{{ user.FullName }}</span>
                </ng-template>
              </p-autoComplete>
            </ng-container>
            <div class="error-msg-colour" *ngIf="isPersonNameMsg">
              Please enter Full Name
            </div>
          </div>
          <div
            class="sub-section-wrapper"
            *ngIf="passTypeRowNameValue === 'Contractor'"
          >
            <span class="section-sub-title"
              >Company Name
              <span class="mandatory">*</span>
            </span>
            <input
              type="text"
              pInputText
              placeholder="Company Name"
              [(ngModel)]="passRequestForFormData.CompanyName"
              [disabled]="disablePOB"
            />
            <div class="error-msg-colour" *ngIf="isPersonCompanyMsg">
              Please enter Company Name
            </div>
          </div>
          <div
            class="sub-section-wrapper"
            *ngIf="passTypeRowNameValue === 'Contractor'"
          >
            <span class="section-sub-title"
              >Job Description

              <span class="mandatory">*</span>
            </span>

            <ara-textarea
              [sourceText]="passRequestForFormData.JobDescription"
              [maxLength]="1000"
              [disabled]="disablePOB"
              (output)="getRemarks($event, 'Job Description')"
            >
            </ara-textarea>

            <div class="error-msg-colour" *ngIf="isJobDescpMsg">
              Please enter Job Description
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div
            class="sub-section-wrapper"
            *ngIf="passTypeRowNameValue === 'Staff'"
          >
            <span class="section-sub-title"
              >Department Name
              <span class="mandatory">*</span>
            </span>
            <input
              type="text"
              pInputText
              placeholder="Department Name"
              [(ngModel)]="passRequestForFormData.DepartmentName"
              [disabled]="disablePOB"
            />
            <div class="error-msg-colour" *ngIf="isDepartmentMsg">
              Please enter Department Name
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ passTypeRowNameValue === "Staff" ? "Staff ID" : "ID" }}
              <span class="mandatory">*</span>
            </span>
            <input
              type="text"
              pInputText
              placeholder="ID"
              [(ngModel)]="passRequestForFormData.Id"
              [disabled]="disablePOB"
            />
            <div class="error-msg-colour" *ngIf="isIdMsg">Please enter ID</div>
          </div>
          <div class="sub-section-wrapper" *ngIf="false">
            <span class="section-sub-title"
              >ID Validity
              <span class="mandatory">*</span>
            </span>
            <p-calendar
              [(ngModel)]="passRequestForFormData.ValidityDate"
              [minDate]="minDate"
              [showIcon]="true"
              dateFormat="dd/mm/yy"
              [disabled]="disablePOB"
              (onSelect)="setDates(passRequestForFormData.ValidityDate)"
              monthNavigator="true"
              yearNavigator="true"
              yearRange="1950:2100"
              readonlyInput="true"
            >
            </p-calendar>
            <div
              *ngIf="isValidityDateMsg && !passRequestForFormData.ValidityDate"
            >
              <span class="error-msg-colour">{{
                "PERSON-ON-BOARD.KINDLY_SELECT_VALIDITY_DATE" | translate
              }}</span>
            </div>
          </div>
          <div
            class="sub-section-wrapper"
            *ngIf="passTypeRowNameValue === 'Contractor'"
          >
            <span class="section-sub-title"
              >Designation
              <span class="mandatory">*</span>
            </span>
            <select
              class="form-control"
              [(ngModel)]="passRequestForFormData.Designation"
              (change)="addPrerequisite(passRequestForFormData.Designation)"
              [disabled]="disablePOB"
            >
              <option value="1">Driver</option>
              <option value="2">Banksman</option>
              <option value="3">PTW Holder</option>
              <option value="5">HSE Personal</option>
              <option value="4">Other</option>
            </select>
            <div class="error-msg-colour" *ngIf="isDesignationMsg">
              Please enter Designation
            </div>
          </div>
          <div
            class="sub-section-wrapper"
            *ngIf="passRequestForFormData.Designation === '4'"
          >
            <input
              type="text"
              pInputText
              placeholder="Other Designation"
              [(ngModel)]="passRequestForFormData.DesignationText"
              [disabled]="disablePOB"
            />
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >Email ID
              <span
                class="mandatory"
                *ngIf="passTypeRowNameValue === 'Contractor'"
                >*</span
              >
            </span>
            <input
              type="text"
              appEmailvalidator
              pInputText
              placeholder="me@example.com"
              required
              [(ngModel)]="passRequestForFormData.EmailId"
              #EmailId="ngModel"
              [disabled]="disablePOB"
            />
            <div *ngIf="EmailId.errors && (EmailId.dirty || EmailId.touched)">
              <span class="error-msg-colour">
                <p *ngIf="EmailId.errors.required">
                  {{ "PERSON-ON-BOARD.EMAIL_IS_REQUIRED" | translate }}
                </p>
                <p *ngIf="EmailId.errors.emailvalidator">
                  {{
                    "PERSON-ON-BOARD.PLEASE_PROVIDE_A_VALID_EMAIL_ADDRESS"
                      | translate
                  }}
                </p>
              </span>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <div
            class="sub-section-wrapper"
            *ngIf="passTypeRowNameValue === 'Staff'"
          >
            <span class="section-sub-title"
              >Company Name
              <span class="mandatory">*</span>
            </span>
            <input
              type="text"
              pInputText
              placeholder="Company Name"
              [value]="passRequestForFormData.CompanyName"
              [disabled]="disablePOB"
            />
          </div>
          <div
            class="sub-section-wrapper"
            *ngIf="passTypeRowNameValue === 'Contractor'"
          >
            <span class="section-sub-title"
              >Validity From
              <span class="mandatory">*</span>
            </span>
            <p-calendar
              [(ngModel)]="passRequestForFormData.PassRequestFromDate"
              [showIcon]="true"
              dateFormat="dd/mm/yy"
              [disabled]="disablePOB && !isQualifiedForRenew"
              monthNavigator="true"
              yearNavigator="true"
              yearRange="1950:2100"
              readonlyInput="true"
            ></p-calendar>
            <div
              *ngIf="
                isFromDateMsg && !passRequestForFormData.PassRequestFromDate
              "
            >
              <span class="error-msg-colour">{{
                "PERSON-ON-BOARD.KINDLY_SELECT_DATE_FROM" | translate
              }}</span>
            </div>
          </div>
          <div
            class="sub-section-wrapper"
            *ngIf="passTypeRowNameValue === 'Contractor'"
          >
            <span class="section-sub-title"
              >Validity To
              <span class="mandatory">*</span>
            </span>
            <p-calendar
              [(ngModel)]="passRequestForFormData.PassRequestToDate"
              dateFormat="dd/mm/yy"
              [minDate]="passRequestForFormData.PassRequestFromDate"
              [disabled]="disablePOB && !isQualifiedForRenew"
              [maxDate]="maxPassDate"
              [showIcon]="true"
              (onSelect)="dateValidation()"
              monthNavigator="true"
              yearNavigator="true"
              yearRange="1950:2100"
              readonlyInput="true"
            ></p-calendar>
            <div
              *ngIf="isToDateMsg && !passRequestForFormData.PassRequestToDate"
            >
              <span class="error-msg-colour">{{
                "PERSON-ON-BOARD.KINDLY_SELECT_DATE_TO" | translate
              }}</span>
            </div>
            <div *ngIf="errorMsgForRangeDate">
              <span class="error-msg-colour"
                >{{
                  "PERSON-ON-BOARD.TO_DATE_SHOULD_BE_GREATER_THAN_FROM_DATE."
                    | translate
                }}
              </span>
            </div>
          </div>
          <ara-category
            *ngIf="POBPermission.POB_Admin"
            [moduleId]="moduleId"
            [sourceId]="passrequestId"
            [isActive]="isActive"
            [disabled]="disablePOB"
            (categoryCheckedValueEmittedData)="
              categoryCheckedEmittedValue($event)
            "
          >
          </ara-category>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="section-wrapper no-margin">
            <span class="section-title">{{
              "PERSON-ON-BOARD.DOCUMENTS" | translate
            }}</span>
            <div class="clearfix"></div>
            <div class="form-group">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                <div class="table-responsive">
                  <table class="table table-bordered doc-status-grid">
                    <thead>
                      <tr>
                        <th style="width: 90px">
                          {{ "PERSON-ON-BOARD.PREREQUISITE" | translate }}
                        </th>
                        <th style="width: 180px">
                          {{ "PERSON-ON-BOARD.ATTACHMENT_LINK" | translate }}
                        </th>
                        <th style="width: 130px">
                          {{ "PERSON-ON-BOARD.EXPIRY_DATE" | translate }}
                        </th>
                        <th style="width: 75px">Text</th>
                        <th style="width: 65px">
                          {{ "PERSON-ON-BOARD.DOCUMENT_STATUS" | translate }}
                        </th>
                        <th style="width: 100px" *ngIf="passrequestId > 0">
                          HSE Remarks
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let document of prerequisite; let i = index">
                        <td>
                          {{ document.Name }}
                          <span
                            class="mandatory"
                            *ngIf="document.IsDocumnentErrorMsg"
                            >*</span
                          >
                        </td>
                        <td>
                          <ara-file-upload
                            [accept]="accept"
                            [multiple]="multiple"
                            [ImageOnly]="
                              document.TypeOfData === 'Image' ? true : false
                            "
                            [(inputFiles)]="document.HSECheckDocuments"
                            [disabled]="
                              document.TypeOfData !== 'Document' &&
                              disablePOB &&
                              ContractHolderId !== loggedInUserJSON.UserId &&
                              SecurityCoordinatorId !== loggedInUserJSON.UserId
                            "
                            [ngClass]="
                              disablePOB &&
                              ContractHolderId !== loggedInUserJSON.UserId &&
                              SecurityCoordinatorId !== loggedInUserJSON.UserId
                                ? 'disabled'
                                : 'cursor-pointer'
                            "
                          >
                          </ara-file-upload>
                          <ara-files-previewer
                            [files]="document.Documents"
                          ></ara-files-previewer>
                          <span
                            class="error-msg-colour"
                            *ngIf="document.IsDocumnentErrorMsg"
                            >{{ document.Name }} is required!</span
                          >
                          <p
                            style="font-size: 1em; color: red"
                            *ngIf="
                              document.TypeOfData === 'Image' &&
                              document.Name === 'Photo'
                            "
                          >
                            .jpg, .jpeg, or .png format only.
                          </p>
                        </td>
                        <td>
                          <p-calendar
                            [(ngModel)]="document.ExpiryDate"
                            [showIcon]="true"
                            appendTo="body"
                            [minDate]="minDate"
                            [disabled]="
                              !document.IsExpiryNeeded ||
                              (disablePOB &&
                                ContractHolderId !== loggedInUserJSON.UserId &&
                                SecurityCoordinatorId !==
                                  loggedInUserJSON.UserId)
                            "
                            dateFormat="dd/mm/yy"
                            (onSelect)="setDates(document)"
                            monthNavigator="true"
                            yearNavigator="true"
                            yearRange="1950:2100"
                            readonlyInput="true"
                          ></p-calendar>
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="document.Value"
                            [disabled]="disablePOB"
                          />
                        </td>
                        <td class="align-center">
                          <p-dropdown
                            [options]="statusDetails"
                            placeholder="Select"
                            appendTo="body"
                            [(ngModel)]="document.POBHSEDocumentStatusId"
                            required
                            #approvingAuthority="ngModel"
                            [style]="{ width: '100%' }"
                            [disabled]="
                              (disablePOB &&
                                ContractHolderId !== loggedInUserJSON.UserId &&
                                SecurityCoordinatorId !==
                                  loggedInUserJSON.UserId) ||
                              passId === 0
                            "
                          >
                          </p-dropdown>
                        </td>
                        <td *ngIf="passrequestId > 0">
                          <div class="p-inputgroup">
                            <input
                              type="text"
                              pInputText
                              placeholder="HSE Remarks"
                              [(ngModel)]="document.HseRemarks"
                              [disabled]="
                                disablePOB &&
                                ContractHolderId !== loggedInUserJSON.UserId &&
                                SecurityCoordinatorId !==
                                  loggedInUserJSON.UserId
                              "
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="clearfix"></div>
                </div>
                <div class="error-msg-colour" *ngIf="prerequisite.length === 0">
                  No Documents are configured. Please add atleast one document
                  to save new pass. External Documents will not be accepted.
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="breaker"></div>
            <!-- <div class="section-wrapper margin-top-10">
              <div class="col-lg-6 col-md-6 col-sm-6 no-padding"
                *ngIf="(passRequestForFormData.PassRequestStatus !== 'Granted' && passRequestForFormData.PassRequestStatus !== 'Reject' && passId > 0 && passRequestForFormData.ApprovingAuthorityId === loggedInUserJSON.UserId) || (passRequestForFormData.PassRequestStatus !== 'Granted' && passId > 0 && POBPermission.POB_Admin)">
                <div class="labelClass">
                  <label>{{ 'PERSON-ON-BOARD.CONTRACT_HOLDER/HR_APPROVAL' | translate }}</label>
                </div>
                <button class="btn primary-btn" value="Accepted" (click)="checkValidatioinForApproval('Approved')"
                  [disabled]="isDisabled">
                  <i class="fa fa-check"></i> Accept
                </button>
                <button class="btn primary-btn" value="Rejected" (click)="checkValidatioinForApproval('Rejected')">
                  <i class="fa fa-times"></i> Reject
                </button>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 no-padding pull-right"
                *ngIf="passId > 0 && (passRequestForFormData.ApprovingAuthorityId === loggedInUserJSON.UserId || POBPermission.POB_Admin)">
                <label>{{ 'PERSON-ON-BOARD.CONTRACTOR/HSE_REMARKS' | translate }}</label>
                <input type="text" pInputText placeholder="Hse Remarks"
                  [disabled]="disablePOB || passRequestForFormData.ContractorOrHSEStatus === 'Rejected'"
                  [(ngModel)]="contractHolderStatusData.ContractorOrHseRemarks">
                <div *ngIf="showErrormsg && !contractHolderStatusData.ContractorOrHseRemarks ">
                  <span class="error-msg-colour">{{ 'PERSON-ON-BOARD.PLEASE_ENTER_THE_REMARKS.' | translate }}</span>
                </div>
              </div>

              <div class="clearfix"></div>
            </div> -->

            <div
              class="form-group margin-top-10 no-padding-left"
              *ngIf="passrequestId > 0"
            >
              <span class="section-title">{{
                "PERSON-ON-BOARD.APPROVAL" | translate
              }}</span>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th style="width: 100px">
                          {{ "PERSON-ON-BOARD.APPROVAL" | translate }}
                        </th>
                        <th style="width: 100px">
                          {{ "PERSON-ON-BOARD.APPROVER_NAME" | translate }}
                        </th>
                        <th style="width: 100px">
                          {{ "PERSON-ON-BOARD.APPROVEORREJECT" | translate }}
                        </th>
                        <th style="width: 100px">
                          {{ "PERSON-ON-BOARD.REMARKS" | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tr *ngFor="let approval of approvaldata">
                      <td>{{ approval.ApprovalName }}</td>
                      <td>{{ approval.ApproverName }}</td>
                      <td>
                        <input
                          type="button"
                          class="btn btn-primary"
                          value="Approve"
                          (click)="setApproval(true, approval)"
                          [disabled]="
                            (disablePOB &&
                              !POBPermission.POB_Admin &&
                              !POBPermission.POB_Admin_Unit &&
                              approval.ApproverId !==
                                loggedInUserJSON.UserId) ||
                            approval.ApprovalStatus ||
                            POBApprovalDisable
                          "
                        />
                        <input
                          type="button"
                          class="btn btn-primary"
                          value="Reject"
                          (click)="setApproval(false, approval)"
                          [disabled]="
                            (disablePOB &&
                              !POBPermission.POB_Admin &&
                              !POBPermission.POB_Admin_Unit &&
                              approval.ApproverId !==
                                loggedInUserJSON.UserId) ||
                            POBApprovalDisable
                          "
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          [(ngModel)]="approval.Remarks"
                          [disabled]="
                            disablePOB &&
                            !POBPermission.POB_Admin &&
                            !POBPermission.POB_Admin_Unit &&
                            approval.ApproverId !== loggedInUserJSON.UserId
                          "
                        />
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group margin-top-10 no-padding-left">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th style="width: 100px">
                          {{ "PERSON-ON-BOARD.BLOCKED" | translate }}
                        </th>
                        <th style="width: 100px">
                          {{ "PERSON-ON-BOARD.BLOCKED_REMARKS" | translate }}
                        </th>
                        <th style="width: 100px">
                          {{ "PERSON-ON-BOARD.EXPIRY_DATE" | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tr>
                      <td>
                        <label class="radio-inline">
                          <input
                            type="radio"
                            name="Blocked"
                            value="true"
                            [(ngModel)]="isBlocked"
                            [disabled]="disablePOB"
                          />Yes
                        </label>
                        <label class="radio-inline">
                          <input
                            type="radio"
                            name="Blocked"
                            value="false"
                            [(ngModel)]="isBlocked"
                            [disabled]="disablePOB"
                          />No
                        </label>
                      </td>
                      <td>
                        <input
                          type="text"
                          pInputText
                          placeholder="Blocked Remarks"
                          [(ngModel)]="passRequestForFormData.BlockedRemarks"
                          [disabled]="disablePOB || isBlocked === 'false'"
                        />
                        <span class="error-msg-colour" *ngIf="isBlockedRemarks"
                          >Remarks are required while blocking pass.</span
                        >
                      </td>
                      <td>
                        <p-calendar
                          [disabled]="disablePOB || isBlocked === 'false'"
                          [showIcon]="true"
                          appendTo="body"
                          dateFormat="dd/mm/yy"
                          [(ngModel)]="passRequestForFormData.ExpiryDate"
                          monthNavigator="true"
                          yearNavigator="true"
                          yearRange="1950:2100"
                          readonlyInput="true"
                        >
                        </p-calendar>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div class="section-wrapper no-margin" *ngIf="passId > 0">
              <span class="section-title">{{
                "PERSON-ON-BOARD.REQUEST_LOG" | translate
              }}</span>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>{{ "PERSON-ON-BOARD.ACTION" | translate }}</th>
                        <th>{{ "PERSON-ON-BOARD.ACTION_BY" | translate }}</th>
                        <th>{{ "PERSON-ON-BOARD.ACTED_ON" | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let log of passRequestLogInfo; let i = index">
                        <td>{{ log.Action }}</td>
                        <td>{{ log.ActedByUserName }}</td>
                        <td>
                          {{ log.ActedOn | dateTimeFormat : "DD-MM-YYYY" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>

        <div class="clearfix"></div>
        <!-- <div class="col-lg-3 col-md-3 col-sm-3" style="display: none;margin:0 auto;">
          <div id="printableContent">
            <img src="{{passRequestForFormData.PrintPass}}" alt="{{passRequestForFormData.PrintPass}}" width="auto"
              height="auto" />
          </div>
        </div>
        <div class="clearfix"></div> -->
        <div class="breaker"></div>
        <footer>
          <div>
            <ara-record-actions
              *ngIf="passId > 0"
              [SourceId]="passId"
              ModuleName="POB"
              [ShowCancel]="
                (POBPermission.POB_Admin_Unit ||
                  POBPermission.POB_Admin ||
                  independentPermissions.SUPER_Admin) &&
                passRequestForFormData.PassStatusName !== 'Cancelled' &&
                passRequestForFormData.PassStatusName !== 'Deleted' &&
                passRequestForFormData.PassStatusName !== 'Expired' &&
                passRequestForFormData.PassStatusName !== 'Cancelled'
              "
              [ShowDelete]="
                independentPermissions.SUPER_Admin &&
                passRequestForFormData.PassStatusName !== 'Cancelled' &&
                passRequestForFormData.PassStatusName !== 'Deleted'
              "
              [ShowRestate]="
                ((POBPermission.POB_Admin_Unit || POBPermission.POB_Admin) &&
                  passRequestForFormData.PassStatusName === 'Cancelled') ||
                (passRequestForFormData.PassStatusName === 'Expired' &&
                  independentPermissions.SUPER_Admin)
              "
              [Status]="passRequestForFormData.PassStatusName"
              (output)="getOutput($event)"
            ></ara-record-actions>
          </div>
          <button
            type="button"
            *ngIf="passId > 0"
            (click)="ReportshowDialog()"
            class="btn btn-primary primary-btn button-report-log button-float-left"
          >
            Report Log
          </button>
          <!-- <button type="button" *ngIf="passRequestForFormData.PassStatusName ==='Draft'" class="btn btn-primary primary-btn button-draft" (click)="saveAsDraft()">
					  <i class="fa fa-envelope"></i>Save As Draft</button>	 -->
          <button
            *ngIf="passId === 0 && prerequisite.length"
            role="button"
            class="btn btn-primary primary-btn button-submit"
            (click)="saveAndContinuePassRequest()"
          >
            <i class="fa fa-check"></i> Save & Continue
          </button>
          <button
            class="btn btn-primary primary-btn button-pdf"
            *ngIf="passId > 0"
            (click)="downloadPDF()"
          >
            <i class="fa fa-file-pdf-o"></i>Download PDF
          </button>
          <button
            class="btn btn-primary primary-btn button-excel"
            *ngIf="
              passId > 0 && passRequestForFormData.PrintPass && allApproved
            "
            (click)="printDiv()"
          >
            <i class="fa fa-print"></i>Print
          </button>
          <button
            *ngIf="
              passId > 0 && passRequestForFormData.PassStatusName !== 'Draft'
            "
            [title]="
              isInactiveLocation
                ? 'This Location is In Active.New passes cannot be created/updated'
                : ''
            "
            [disabled]="
              (isInactiveLocation &&
                !(
                  independentPermissions.APP_Admin ||
                  independentPermissions.HSE_Admin ||
                  independentPermissions.SUPER_Admin
                )) ||
              (disablePOB &&
                !POBPermission.POB_Admin &&
                !POBPermission.POB_Admin_Unit &&
                ContractHolderId !== loggedInUserJSON.UserId &&
                SecurityCoordinatorId !== loggedInUserJSON.UserId)
            "
            class="btn btn-primary primary-btn button-update"
            (click)="updatePassRequest()"
          >
            <i class="fa fa-share-square"></i> Update
          </button>
          <button
            type="button"
            *ngIf="
              passId > 0 && passRequestForFormData.PassStatusName === 'Draft'
            "
            class="btn btn-primary primary-btn button-submit"
            (click)="updatePassRequest()"
          >
            <i class="fa fa-share-square"></i>submit
          </button>
          <button
            *ngIf="isQualifiedForRenew"
            [disabled]="
              disablePOB &&
              !POBPermission.POB_Admin &&
              !POBPermission.POB_Admin_Unit &&
              ContractHolderId !== loggedInUserJSON.UserId &&
              SecurityCoordinatorId !== loggedInUserJSON.UserId
            "
            class="btn btn-primary primary-btn button-excel"
            (click)="renewRequest()"
          >
            <i class="fa fa-retweet"></i> Renew
          </button>
          <button
            *ngIf="
              passId > 0 && passRequestForFormData.PrintPass && allApproved
            "
            [disabled]="
              disablePOB &&
              !POBPermission.POB_Admin &&
              !POBPermission.POB_Admin_Unit &&
              ContractHolderId !== loggedInUserJSON.UserId &&
              SecurityCoordinatorId !== loggedInUserJSON.UserId
            "
            class="btn btn-primary primary-btn button-excel"
            (click)="recreatePrintPass()"
          >
            <i class="fa fa-print"></i> Recreate Print Pass
          </button>
          <div class="clearfix"></div>
        </footer>
      </div>
      <ara-alerts
        [alertType]="alertType"
        [successDetails]="successDetails"
        [errorDetails]="errorDetails"
        (yesClicked)="onYesClickedForConfirmation()"
        [confirmMessage]="confirmMessage"
        (noClicked)="onNoClickedForConfirmation()"
        (okClicked)="onYesClickedSuccess()"
      ></ara-alerts>
      <span *ngIf="ReportclosePopup">
        <p-dialog
          header="Report History"
          [(visible)]="ReportclosePopup"
          (onHide)="ReportclosePopUp()"
          [modal]="true"
        >
          <ara-report-log
            [ReportUserId]="ReportUserId"
            [ReportModule]="ReportModule"
            [ReportRecordId]="ReportRecordId"
          >
          </ara-report-log>
        </p-dialog>
      </span>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<p-dialog
  header="Printed Pass"
  [(visible)]="downloadPrintDialog"
  modal="modal"
  width="400"
  height="400"
>
  <img
    src="{{ passRequestForFormData.PrintPass }}"
    alt="{{ passRequestForFormData.PrintPass }}"
    width="100%"
    style="object-fit: contain; max-height: 290px"
  />
  <p-footer>
    <button
      class="btn btn-primary primary-btn button-pdf"
      (click)="downloadPass()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button
      class="btn btn-primary primary-btn button-cancel"
      style="display: none"
      (click)="downloadPrintDialog = false"
    >
      Close
    </button>
  </p-footer>
</p-dialog>
